<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';

import WhatsAppCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppCampaign/WhatsAppCampaignForm.vue';

const props = defineProps({
  campaign: {
    type: Object,
    default: null,
  },
  mode: {
    type: String,
    default: 'create', // 'create' | 'edit'
  },
});

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const dialogTitle = computed(() => {
  if (props.mode === 'edit') {
    return 'Editar Campanha do WhatsApp';
  }
  return t('CAMPAIGN.WHATSAPP.CREATE.TITLE') || 'Criar Campanha do WhatsApp';
});

const saveCampaign = async campaignDetails => {
  try {
    if (props.mode === 'edit' && props.campaign?.id) {
      await store.dispatch('campaigns/update', {
        id: props.campaign.id,
        ...campaignDetails,
      });
      useAlert('Campanha atualizada com sucesso!');
    } else {
      await store.dispatch('campaigns/create', campaignDetails);

      useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
        type: CAMPAIGN_TYPES.ONE_OFF,
      });

      useAlert(t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.SUCCESS_MESSAGE') || 'Campanha criada com sucesso!');
    }
    await store.dispatch('campaigns/get', { campaignType: 'one_off' });
    emit('close');
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      error?.message ||
      (props.mode === 'edit' ? 'Erro ao atualizar campanha.' : t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.ERROR_MESSAGE'));
    useAlert(errorMessage);
  }
};

const handleSubmit = campaignDetails => {
  saveCampaign(campaignDetails);
};

const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[28rem] sm:w-[38rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-white dark:bg-n-solid-2 rounded-2xl border border-n-weak shadow-2xl max-h-[88vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-5">
      <div class="flex items-center justify-between pb-3 border-b border-n-weak">
        <h3 class="text-base font-bold text-n-slate-12 flex-shrink-0">
          {{ dialogTitle }}
        </h3>
        <button
          type="button"
          class="text-n-slate-11 hover:text-n-slate-12 p-1.5 rounded-lg hover:bg-n-alpha-2 cursor-pointer transition-colors"
          @click="handleClose"
        >
          <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <WhatsAppCampaignForm
        :campaign="campaign"
        :mode="mode"
        @submit="handleSubmit"
        @cancel="handleClose"
      />
    </div>
  </div>
</template>